const VERTICAL_ASPECT_RATIO = {
  aspectRatio: 0.5625, // 9:16
  cloudAr: "9:16"
};

const PORTRAIT_ASPECT_RATIO = {
  aspectRatio: 1, // 1:1
  cloudAr: "1:1"
};

const LANDSCAPE_ASPECT_RATIO = {
  aspectRatio: 1.91, // 16:9
  cloudAr: "16:9"
};

// Predefined sizes for different breakpoints
// New sizes
// const SIZES = {
//   default: {
//     PortraitImage: { width: 241, height: 241 },
//     LandscapeImage: { width: 230, height: 120 },
//     VerticalImage: { width: 225, height: 400 }
//   },
//   1440: {
//     PortraitImage: { width: 290, height: 290 },
//     LandscapeImage: { width: 274, height: 143 },
//     VerticalImage: { width: 280, height: 498 }
//   }
// };

// Personal opinion
const SIZES = {
  default: {
    PortraitImage: { width: 241, height: 241 },
    LandscapeImage: { width: 230, height: 120 },
    VerticalImage: { width: 225, height: 400 }
  },
  1440: {
    PortraitImage: { width: 290, height: 290 },
    LandscapeImage: { width: 274, height: 143 },
    VerticalImage: { width: 280, height: 498 }
  },
  1920: {
    PortraitImage: { width: 320, height: 320 },
    LandscapeImage: { width: 360, height: 189 },
    VerticalImage: { width: 288, height: 512 }
  },
  2560: {
    PortraitImage: { width: 380, height: 380 },
    LandscapeImage: { width: 420, height: 220 },
    VerticalImage: { width: 360, height: 640 }
  }
};

export const imageSizeTemplates = {
  WaveImage: {
    vertical: {
      widthImage: 1080,
      heightImage: Math.round(1920 * 0.7)
    },
    portrait: {
      widthImage: Math.round(2000 * 0.63),
      heightImage: 2000
    },
    landscape: {
      widthImage: Math.round(1952 * 0.68),
      heightImage: 1022
    }
  },
  OneToneImage: {
    vertical: {
      widthImage: Math.round(1080 * 0.7),
      heightImage: 1130
    },
    portrait: {
      widthImage: Math.round(2000 * 0.45),
      heightImage: 1760
    },
    landscape: {
      widthImage: Math.round(1952 * 0.45),
      heightImage: 900
    }
  },
  DefaultImage: {
    vertical: {
      widthImage: 1080,
      heightImage: 1920
    },
    portrait: {
      widthImage: 2000,
      heightImage: 2000
    },
    landscape: {
      widthImage: 1952,
      heightImage: 1022
    }
  }
};

/**
 * Get ad assistant dimensions based on screen size and device pixel ratio.
 * @returns {Object} The dimensions for different image types.
 */
export const getAdAssistantDimensions = () => {
  if (typeof window === "undefined") {
    return SIZES.default; // Fallback for server-side execution
  }

  const screenWidth = window.innerWidth;

  let sizes = SIZES.default;
  if (screenWidth >= 2560) {
    sizes = SIZES[2560];
  } else if (screenWidth >= 1920) {
    sizes = SIZES[1920];
  } else if (screenWidth >= 1440) {
    sizes = SIZES[1440];
  }

  return {
    PortraitImage: { ...sizes.PortraitImage, ...PORTRAIT_ASPECT_RATIO },
    LandscapeImage: { ...sizes.LandscapeImage, ...LANDSCAPE_ASPECT_RATIO },
    VerticalImage: { ...sizes.VerticalImage, ...VERTICAL_ASPECT_RATIO },
    WaveImage: {
      vertical: {
        ...sizes.VerticalImage,
        ...VERTICAL_ASPECT_RATIO,
        ...imageSizeTemplates.WaveImage.vertical
      },
      portrait: {
        ...sizes.PortraitImage,
        ...PORTRAIT_ASPECT_RATIO,
        ...imageSizeTemplates.WaveImage.portrait
      },
      landscape: {
        ...sizes.LandscapeImage,
        ...LANDSCAPE_ASPECT_RATIO,
        ...imageSizeTemplates.WaveImage.landscape
      }
    },
    OneToneImage: {
      vertical: {
        ...sizes.VerticalImage,
        ...VERTICAL_ASPECT_RATIO,
        ...imageSizeTemplates.OneToneImage.vertical
      },
      portrait: {
        ...sizes.PortraitImage,
        ...PORTRAIT_ASPECT_RATIO,
        ...imageSizeTemplates.OneToneImage.portrait
      },
      landscape: {
        ...sizes.LandscapeImage,
        ...LANDSCAPE_ASPECT_RATIO,
        ...imageSizeTemplates.OneToneImage.landscape
      }
    },
    OneToneVideo: {
      vertical: { ...sizes.VerticalImage, ...VERTICAL_ASPECT_RATIO },
      portrait: { ...sizes.PortraitImage, ...PORTRAIT_ASPECT_RATIO },
      landscape: { ...sizes.LandscapeImage, ...LANDSCAPE_ASPECT_RATIO }
    },
    WaveVideo: {
      vertical: { ...sizes.VerticalImage, ...VERTICAL_ASPECT_RATIO },
      portrait: { ...sizes.PortraitImage, ...PORTRAIT_ASPECT_RATIO },
      landscape: { ...sizes.LandscapeImage, ...LANDSCAPE_ASPECT_RATIO }
    },
    DefaultImage: {
      vertical: {
        ...sizes.VerticalImage,
        ...VERTICAL_ASPECT_RATIO,
        ...imageSizeTemplates.DefaultImage.vertical
      },
      portrait: {
        ...sizes.PortraitImage,
        ...PORTRAIT_ASPECT_RATIO,
        ...imageSizeTemplates.DefaultImage.portrait
      },
      landscape: {
        ...sizes.LandscapeImage,
        ...LANDSCAPE_ASPECT_RATIO,
        ...imageSizeTemplates.DefaultImage.landscape
      }
    },
    default: { ...sizes.PortraitImage, ...PORTRAIT_ASPECT_RATIO }
  };
};
